export default __webpack_public_path__ + "static/media/analytics-background.28fd6c93.svg";